import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaBullhorn,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const PromotionalVideoServicesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Promotional Video Services in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Promotional Video Services</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our promotional video services in **Al Barsha**
            deliver dynamic, high-impact videos that boost your brand’s
            visibility and drive engagement. From product launches to marketing
            campaigns, we create content that captivates and converts.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1601506521941-ca8a9ea2f0db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Creative video production
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Dynamic video content
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Promotional Video Services in Al Barsha"
        description="We craft promotional videos that combine creativity and strategy to maximize impact."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Attention-Grabbing",
            description: "Bold visuals that hook your audience instantly.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Narratives that resonate and drive action.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery to meet your campaign deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Optimized",
            description: "Tailored for social media, websites, and ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for promotional videos.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full Production",
            description: "From concept to final cut, we handle it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Promotional Video Production Process"
        description={
          <Description>
            We deliver impactful promotional videos through a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Align with your campaign goals and brand vision.
              </li>
              <li>Storyboarding: Craft a compelling promotional narrative.</li>
              <li>Filming: Capture vibrant footage with top-tier equipment.</li>
              <li>Editing: Enhance with effects, music, and brand elements.</li>
              <li>Review: Ensure the video meets your expectations.</li>
              <li>
                Delivery: Provide ready-to-launch content for your platforms.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Storyboarding session
          "https://images.unsplash.com/photo-1603729340594-9e0c31e0063b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Camera equipment closeup
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Promotional Video Wins in Al Barsha"
        description="Our promotional videos have transformed marketing campaigns in Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Impact",
            description: "Drove 12x engagement for a local product launch.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Boosted reach for an Al Barsha business campaign.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction from promotional clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Impactful Videos?</Subheading>}
        heading="Promotional Video Services in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional promotional video
            services in Al Barsha. Create dynamic, high-impact videos that
            elevate your brand and drive conversions—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1583217874484-9e3a5ee3dd5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai cityscape/skyline
          "https://images.unsplash.com/photo-1524649466382-c1c6b5b6e9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80", // Creative marketing team
          "https://images.unsplash.com/photo-1551218372-a8dadaee604a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
